import { EnvironmentSensorType } from '@mgh-app/component-library';
import {
  HistEnvMonDisplayedSensorTypes,
  histEnvMonHiddenSensorTypes,
} from 'models/environmentalMonitoringSensor';

export const isDisplayedSensorType = (
  type: EnvironmentSensorType | HistEnvMonDisplayedSensorTypes,
): type is HistEnvMonDisplayedSensorTypes => !Object.hasOwn(histEnvMonHiddenSensorTypes, type);
